import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getBookingTypeById, updateBookingType } from "adminApi/RoomBookingTypeListsApi/RoomBookingTypeLists";
import { BookingTypeRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import EditBookingForm from "./EditBookingForm";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import { validateForm } from "utils/validation";
import fields from "../json/BookingTypeListFields.json";
import useFetchFormDataById from "Hooks/useFetchFormDataById";

const EditBookingType = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const { formdata } = fields;

    // Build initial values from field definitions
    const initialValues = formdata.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {});

    const { values, errors, handleChange, setValues, setErrors } = useFormChange(initialValues, BookingTypeRules);

    // Fetch existing record by ID and populate form
    const { loading: loadingFetch } = useFetchFormDataById(id, formdata, getBookingTypeById, setValues);

    const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
        // Send plain JSON — no file uploads in this form
        async (formValues) => await updateBookingType({ id, data: formValues }),
        (vals) => {
            const err = validateForm(vals, BookingTypeRules);
            setErrors(err);
            return err;
        },
        () => navigate(-1),
        "Booking Type updated successfully"
    );

    return (
        <>
            {(loadingSubmit || loadingFetch) && <Spinner isSpinner={true} />}
            <EditBookingForm
                fields={formdata}
                values={values}
                errors={errors}
                handleChange={handleChange}
                handleSubmit={(e) => handleSubmit(e, values)}
                loading={loadingSubmit}
                title="Edit Booking Type"
            />
        </>
    );
};

export default EditBookingType;
